module.exports = __webpack_public_path__ + "img/icon-bondholder-nav.13b210a7.svg";